export class A3LEmployeeCustomDataUpdateRequest {
  employees: string[];
  customDataValue: string;
  templateName: string;
  elementName: string;
}
